import React, { forwardRef, type ForwardRefExoticComponent, type RefAttributes } from 'react';
import {
	PrimaryButton as FullPrimaryButton,
	type PrimaryButtonProps,
} from '@atlaskit/atlassian-navigation';
import { SkeletonPrimaryButton } from '@atlaskit/atlassian-navigation/skeleton';

type PrimaryButtonType = ForwardRefExoticComponent<
	Omit<PrimaryButtonProps, 'ref'> & RefAttributes<HTMLElement>
>;

export const PrimaryButton: PrimaryButtonType = forwardRef<HTMLElement, PrimaryButtonProps>(
	(props, ref) => {
		if (__SERVER__) {
			return (
				<SkeletonPrimaryButton
					text={props.children === undefined ? '' : props.children}
					isHighlighted={props.isHighlighted}
				/>
			);
		}

		const buttonProps = {
			...props,
			ref,
		};

		return <FullPrimaryButton {...buttonProps} />;
	},
);
